import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../store';

const getEnvironmentState = (state: RootState) => state.environment;

export const getEnvironmentSelector = () => {
  return createSelector(getEnvironmentState, (environment) => environment);
};
